import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCA_-Vv9JZTNZciO8BRHyL98Oa1wRF4WdQ",
  authDomain: "animal-shelter-swg.firebaseapp.com",
  projectId: "animal-shelter-swg",
  storageBucket: "animal-shelter-swg.firebasestorage.app",
  messagingSenderId: "89344334199",
  appId: "1:89344334199:web:8f473a0cf7545431df6972"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};